import { render } from "./Contact_index_m.vue?vue&type=template&id=fd5749a8&scoped=true"
import script from "./Contact_index_m.vue?vue&type=script&lang=js"
export * from "./Contact_index_m.vue?vue&type=script&lang=js"

import "./Contact_index_m.vue?vue&type=style&index=0&id=fd5749a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fd5749a8"

export default script